import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'na'
})
export class NaPipe implements PipeTransform {

  transform(value: string | number): string | number {
    return value ? value : 'Non disponible';
  }

}
